// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gr-a";
export var fulfillmentFormRail = "_gr-9";
export var headerTitleRow = "_gr-c";
export var orderDetailsWrapper = "_gr-7";
export var orderLinkTrigger = "_gr-2";
export var paymentInformationGrid = "_gr-h";
export var paymentSummaryColumn = "_gr-i";
export var shipmentContainer = "_gr-b";
export var shipmentDetailsMainPane = "_gr-8";
export var shipmentNavigationCard = "_gr-5";
export var shipmentNavigationRail = "_gr-3";
export var shipmentNavigationRailHeader = "_gr-4";
export var shipmentSummaryFact = "_gr-e";
export var shipmentSummaryGrid = "_gr-d";
export var shipmentSummaryMetadataRow = "_gr-f";
export var shipmentSummaryTags = "_gr-g";
export var shipmentWorkspace = "_gr-0";
export var shipmentWorkspaceContent = "_gr-6";
export var shipmentWorkspaceHeader = "_gr-1";